import React, {Component} from 'react';
import {
    CaretDownOutlined,
    EditOutlined,
    LogoutOutlined,
    ExclamationCircleOutlined,
} from '@ant-design/icons';
import {Menu, Dropdown, Modal} from 'antd';
import {toLogin} from 'src/commons';
import ModifyPassword from './ModifyPassword';
import config from 'src/commons/config-hoc';
import './style.less';
import Cookies from 'js-cookie'
import {consumeWeakPasswordReminder} from 'src/utils/weak_password_reminder';

const Item = Menu.Item;

@config({ajax: true, router: true,})

export default class HeaderUser extends Component {
    static defaultProps = {
        theme: 'default',
    };

    state = {
        passwordVisible: false,
    };

    componentDidMount() {
        const reminder = consumeWeakPasswordReminder();
        if (reminder) {
            Modal.confirm({
                title: '密码安全提醒',
                icon: <ExclamationCircleOutlined/>,
                content: reminder.passwordTip,
                okText: '立即修改',
                cancelText: '稍后修改',
                onOk: () => this.setState({passwordVisible: true}),
            });
        }
    }

    handleMenuClick = ({key}) => {
        if (key === 'logout') {
            Cookies.set('plant01_user', '', {expires: 1});
            Cookies.set('userId', '', {expires: 1});
            Cookies.set('plant01_token', '', {expires: 1});
            Cookies.set('plant01_token_type', '', {expires: 1});
            this.props.ajax.post('/mock/logout').then(toLogin);
        }

        if (key === 'modifyPassword') {
            this.setState({passwordVisible: true});
        }

        if (key === 'update_log') {
            this.props.history.push('/update_log')
        }
    };

    render() {
        const name = Cookies.get('plant01_user');
        const {className, theme} = this.props;
        const {passwordVisible} = this.state;
        const menu = (
            <Menu styleName="menu" theme={theme} selectedKeys={[]} onClick={this.handleMenuClick}>
                <Item key="modifyPassword"><EditOutlined/>修改密码</Item>
                {/*<Item><Link to="/settings"><SettingOutlined/>设置</Link></Item>*/}
                <Menu.Divider/>
                {/*<Item key="update_log"><FlagOutlined />更新日志</Item>*/}
                {/*<Menu.Divider/>*/}
                <Item key="logout"><LogoutOutlined/>退出登录</Item>
            </Menu>
        );
        return (
            <div styleName="user-menu" ref={node => this.userMenu = node}>
                <Dropdown overlay={menu} getPopupContainer={() => (this.userMenu || document.body)}>
                    <span styleName="account" className={className}>
                        <span styleName="user-name">{name}</span>
                        <CaretDownOutlined/>
                    </span>
                </Dropdown>

                <ModifyPassword
                    visible={passwordVisible}
                    onOk={() => this.setState({passwordVisible: false})}
                    onCancel={() => this.setState({passwordVisible: false})}
                />
            </div>
        );
    }
}
